import React from "react";

export default function useRandom<T>(items: T[]) {
  const [randomIndex] = React.useState(Math.floor(Math.random() * items.length));
  return items[randomIndex];
}
